import React from "react";
import CrudManager from "../../../../components/common/CrudManager";
import { faTable } from "@fortawesome/free-solid-svg-icons";

// Joins that duplicate the header row once per joined child row (e.g. one row
// per sales line). When a value here is true, CrudManager groups those rows
// back into a single visual row by default (see table-config.yml
// joins.<key>.frontend.groupDuplicateRows). Users can still toggle this from
// the grid UI; their choice is persisted per-user and overrides this default.
const JOIN_ROW_GROUPING_DEFAULTS = {};

const CustomerItemEquivalencesPageGen = ({ service, transformColumns, crudConfigOverride }) => {
  const formTabs = null;

  const baseColumns = [
    {
      key: "recId",
      label: "customerItemEquivalences.recId",
      fieldPermissionControlled: true,
      sortable: true,
      showInGrid: false,
      showInForm: false,
      showInFilter: true,
      editable: false,
      disabled: false,
      type: "number",
      filterType: "number"    },
    {
      key: "dataAreaId",
      label: "customerItemEquivalences.dataAreaId",
      fieldPermissionControlled: true,
      sortable: true,
      showInGrid: false,
      showInForm: false,
      showInFilter: true,
      editable: false,
      disabled: false,
      type: "text"    },
    {
      key: "custaccount",
      label: "customerItemEquivalences.custaccount",
      fieldPermissionControlled: true,
      sortable: true,
      showInGrid: true,
      showInForm: true,
      showInFilter: true,
      editable: true,
      disabled: false,
      type: "text"    },
    {
      key: "customeritemcode",
      label: "customerItemEquivalences.customeritemcode",
      fieldPermissionControlled: true,
      sortable: true,
      showInGrid: true,
      showInForm: true,
      showInFilter: true,
      editable: true,
      disabled: false,
      type: "text"    },
    {
      key: "itemId",
      label: "customerItemEquivalences.itemId",
      fieldPermissionControlled: true,
      sortable: true,
      showInGrid: true,
      showInForm: true,
      showInFilter: true,
      editable: true,
      disabled: false,
      type: "text"    },
    {
      key: "sourceisalesid",
      label: "customerItemEquivalences.sourceisalesid",
      fieldPermissionControlled: true,
      sortable: true,
      showInGrid: false,
      showInForm: true,
      showInFilter: true,
      editable: false,
      disabled: true,
      type: "text"    },
    {
      key: "sourcepurchorderformnum",
      label: "customerItemEquivalences.sourcepurchorderformnum",
      fieldPermissionControlled: true,
      sortable: true,
      showInGrid: true,
      showInForm: true,
      showInFilter: true,
      editable: false,
      disabled: true,
      type: "text"    },
    {
      key: "learnsource",
      label: "customerItemEquivalences.learnsource",
      fieldPermissionControlled: true,
      sortable: true,
      showInGrid: true,
      showInForm: true,
      showInFilter: true,
      editable: false,
      disabled: true,
      type: "text"    },
    {
      key: "matchscore",
      label: "customerItemEquivalences.matchscore",
      fieldPermissionControlled: true,
      sortable: true,
      showInGrid: false,
      showInForm: true,
      showInFilter: true,
      editable: false,
      disabled: true,
      type: "number",
      filterType: "number"    },
    {
      key: "hitcount",
      label: "customerItemEquivalences.hitcount",
      fieldPermissionControlled: true,
      sortable: true,
      showInGrid: true,
      showInForm: true,
      showInFilter: true,
      editable: true,
      disabled: false,
      type: "number",
      filterType: "number"    },
    {
      key: "isactive",
      label: "customerItemEquivalences.isactive",
      fieldPermissionControlled: true,
      sortable: true,
      showInGrid: true,
      showInForm: true,
      showInFilter: true,
      editable: true,
      disabled: false,
      type: "number",
      filterType: "number"    },
    {
      key: "createddate",
      label: "customerItemEquivalences.createddate",
      fieldPermissionControlled: true,
      sortable: true,
      showInGrid: false,
      showInForm: true,
      showInFilter: false,
      editable: false,
      disabled: true,
      type: "date",
      filterType: "date"    },
    {
      key: "modifieddate",
      label: "customerItemEquivalences.modifieddate",
      fieldPermissionControlled: true,
      sortable: true,
      showInGrid: false,
      showInForm: true,
      showInFilter: false,
      editable: false,
      disabled: true,
      type: "date",
      filterType: "date"    },
    {
      key: "equivalencetype",
      label: "customerItemEquivalences.equivalencetype",
      fieldPermissionControlled: true,
      sortable: true,
      showInGrid: true,
      showInForm: true,
      showInFilter: true,
      editable: true,
      disabled: false,
      type: "text"    },
    {
      key: "familytypeitemid",
      label: "customerItemEquivalences.familytypeitemid",
      fieldPermissionControlled: true,
      sortable: true,
      showInGrid: true,
      showInForm: true,
      showInFilter: true,
      editable: true,
      disabled: false,
      type: "text"    },
    {
      key: "familyvenditemid",
      label: "customerItemEquivalences.familyvenditemid",
      fieldPermissionControlled: true,
      sortable: true,
      showInGrid: true,
      showInForm: true,
      showInFilter: true,
      editable: true,
      disabled: false,
      type: "text"    },
    {
      key: "familygramajeitemid",
      label: "customerItemEquivalences.familygramajeitemid",
      fieldPermissionControlled: true,
      sortable: true,
      showInGrid: true,
      showInForm: true,
      showInFilter: true,
      editable: true,
      disabled: false,
      type: "text"    },
  ];

  const columns = transformColumns ? transformColumns(baseColumns) : baseColumns;
  const initialFormData = columns.reduce((acc, col) => {
    if (
      col &&
      col.showInForm &&
      Object.prototype.hasOwnProperty.call(col, "defaultValue")
    ) {
      acc[col.key] = col.defaultValue;
    }
    return acc;
  }, {});

  const defaultCrudConfig = {
    canCreate: true,
    canEdit: true,
    canDelete: false
  };

  const crudConfig = {
    ...defaultCrudConfig,
    ...(crudConfigOverride || {})
  };

  return (
    <CrudManager
      service={service}
      columns={columns}
      entityName="customerItemEquivalences"
      permissionPrefix="legacy.customerItemEquivalences"
      icon={faTable}
      formLayout="modal"
      canCreate={crudConfig.canCreate}
      canEdit={crudConfig.canEdit}
      canDelete={crudConfig.canDelete}
      initialFilters={crudConfig.initialFilters || {}}
      initialSort={crudConfig.initialSort || null}
      gridRowStyleResolver={crudConfig.gridRowStyleResolver || null}
      joinRowGroupingDefaults={JOIN_ROW_GROUPING_DEFAULTS}
      renderForm={crudConfig.renderForm || null}
      modalClassName={crudConfig.modalClassName || ""}
      formTabs={formTabs}
      initialFormData={initialFormData}
    />
  );
};

export default CustomerItemEquivalencesPageGen;